module.exports = __webpack_public_path__ + "img/change-password-en.edb3500.png";